import { createContext } from "react";

export enum LocaleLangE {
  EN = "EN",
  RU = "RU",
}
interface LocaleI {
  locale: LocaleLangE;
  setLocale(l: LocaleLangE): void;
}

export const LocaleContext = createContext<LocaleI>({
  locale: LocaleLangE.RU,
  setLocale: () => null,
});
